import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilterChips = ({ 
  activeFilters = {},
  onRemoveFilter,
  onClearAll,
  className = ''
}) => {
  const getFilterChips = () => {
    const chips = [];
    
    if (activeFilters?.birthdayMonth) {
      const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      chips?.push({
        key: 'birthdayMonth',
        label: `Birthday: ${monthNames?.[activeFilters?.birthdayMonth - 1]}`,
        value: activeFilters?.birthdayMonth
      });
    }
    
    if (activeFilters?.tags && activeFilters?.tags?.length > 0) {
      activeFilters?.tags?.forEach(tag => {
        chips?.push({
          key: 'tags',
          label: `Tag: ${tag}`,
          value: tag
        });
      });
    }
    
    if (activeFilters?.recentActivity) {
      const activityLabels = {
        'today': 'Contacted Today',
        'week': 'Contacted This Week',
        'month': 'Contacted This Month',
        'never': 'Never Contacted'
      };
      chips?.push({
        key: 'recentActivity',
        label: activityLabels?.[activeFilters?.recentActivity] || activeFilters?.recentActivity,
        value: activeFilters?.recentActivity
      });
    }
    
    if (activeFilters?.favorites) {
      chips?.push({
        key: 'favorites',
        label: 'Favorites Only',
        value: true
      });
    }
    
    if (activeFilters?.company) {
      chips?.push({
        key: 'company',
        label: `Company: ${activeFilters?.company}`,
        value: activeFilters?.company
      });
    }
    
    if (activeFilters?.location) {
      chips?.push({
        key: 'location',
        label: `Location: ${activeFilters?.location}`,
        value: activeFilters?.location
      });
    }
    
    return chips;
  };

  const filterChips = getFilterChips();

  if (filterChips?.length === 0) {
    return null;
  }

  const handleRemoveFilter = (filterKey, filterValue) => {
    onRemoveFilter(filterKey, filterValue);
  };

  return (
    <div className={`flex items-center space-x-2 py-2 ${className}`}>
      <div className="flex items-center space-x-2 flex-wrap gap-2">
        {filterChips?.map((chip, index) => (
          <div
            key={`${chip?.key}-${chip?.value}-${index}`}
            className="flex items-center space-x-1 bg-primary/10 text-primary px-3 py-1 rounded-full text-sm border border-primary/20"
          >
            <span className="truncate max-w-32">
              {chip?.label}
            </span>
            <button
              onClick={() => handleRemoveFilter(chip?.key, chip?.value)}
              className="hover:bg-primary/20 rounded-full p-0.5 transition-micro"
            >
              <Icon name="X" size={14} />
            </button>
          </div>
        ))}
        
        {filterChips?.length > 1 && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearAll}
            className="text-text-secondary hover:text-text-primary"
          >
            Clear All
          </Button>
        )}
      </div>
    </div>
  );
};

export default FilterChips;